import { render, staticRenderFns } from "./ApprovalProcessApproved.vue?vue&type=template&id=1b04da10&scoped=true"
import script from "./ApprovalProcessApproved.vue?vue&type=script&lang=js"
export * from "./ApprovalProcessApproved.vue?vue&type=script&lang=js"
import style0 from "./ApprovalProcessApproved.vue?vue&type=style&index=0&id=1b04da10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b04da10",
  null
  
)

export default component.exports